import React from 'react';
import { Linkedin, Instagram, Mail, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-night-950 text-white pt-20 pb-8 overflow-hidden">
      <div className="absolute inset-x-0 top-0 hairline-green" />

      <div className="container-custom relative">
        {/* Logo + giant brand wordmark */}
        <div className="mb-16">
          <img
            src="/logo-light.png"
            alt="AgroTech Inteli"
            className="h-14 md:h-16 w-auto object-contain mb-10"
          />
          <h2 className="font-display font-black tracking-tightest leading-[0.85] text-[clamp(3rem,12vw,11rem)] text-mist-50">
            AgroTech<br />
            <span className="text-gradient">Inteli</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          {/* About */}
          <div className="md:col-span-5">
            <p className="text-mist-400 leading-relaxed max-w-md">
              A primeira liga estudantil 100% focada em desenvolver soluções tecnológicas
              de código aberto para os desafios reais do agronegócio brasileiro.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h3 className="text-xs uppercase tracking-[0.2em] text-mist-500 mb-4">Navegação</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Início', href: '#home' },
                { label: 'Sobre', href: '#about' },
                { label: 'Galeria', href: '#gallery' },
                { label: 'Cases', href: '#cases' },
                { label: 'Gestão', href: '#management' },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="group inline-flex items-center gap-2 text-mist-300 hover:text-primary-400 transition-colors">
                    {l.label}
                    <ArrowUpRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://www.inteli.edu.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-2 text-mist-300 hover:text-primary-400 transition-colors"
                >
                  Site do Inteli
                  <ArrowUpRight size={14} className="opacity-50" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h3 className="text-xs uppercase tracking-[0.2em] text-mist-500 mb-4">Contato</h3>
            <a
              href="mailto:agrotech@inteli.edu.br"
              className="inline-flex items-center gap-2 text-mist-200 hover:text-primary-400 transition-colors mb-6"
            >
              <Mail size={16} />
              agrotech@inteli.edu.br
            </a>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/agrotech-inteli/"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 rounded-full bg-white/[0.06] hover:bg-[#0A66C2] hover:text-white border border-white/10 hover:border-[#0A66C2] flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.instagram.com/agrotech_inteli/"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 rounded-full bg-white/[0.06] hover:bg-gradient-to-r hover:from-fuchsia-600 hover:to-pink-600 border border-white/10 flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="hairline mb-6" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-mist-500">
          <p>&copy; {currentYear} AgroTech Inteli. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
